export const TOOLTIP_MESSAGES = {
  insufficientAccess: "You do not have edit access. Contact Admin.",
};
